import type { FC } from "react";

import {
	deleteAllSongs,
	useLastSongSelector,
	saveCurrentSong,
	saveLastSong,
	setVolumeBarDisplay,
	pushToWaitingListAtPosition,
} from "@redux/player";
import analytics from "lib/analytics";
import { useDispatch } from "react-redux";

import { sendMultiScreenEventToIpad } from "services/helpers/multiScreen";
import { useTvToIpadMultiScreenEventsListener } from "services/hooks/useMultiScreenEventListener";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { PlayerEvent } from "shared-types/player-event";

import LastSongItemText from "./LastSongItemText";
import { Stack } from "@mui/material";
import { useWaitingListData } from "services/hooks/useWaitingListData";

const LastSongItemWrapper: FC = () => {
	const { splitWaitingList, waitingList } = useWaitingListData();
	const lastSong = useLastSongSelector();
	const dispatch = useDispatch();

	const getLastPosition = () => {
		if (splitWaitingList.elapsedTimeWaitingList.length <= 0) {
			return waitingList.length;
		}

		const firstElapsedSong = splitWaitingList.elapsedTimeWaitingList[0];
		if (firstElapsedSong) {
			const index = waitingList.findIndex(
				(song) => song.id === firstElapsedSong.song.id,
			);
			return index + 1;
		}

		return 0;
	};

	const clearLastSong = () => {
		if (lastSong?.song) {
			dispatch(pushToWaitingListAtPosition({ song: lastSong?.song, position: getLastPosition() }));
		}
		dispatch(saveLastSong(null));
		analytics.track("waitingList_lastSong_remove");
	};

	useTvToIpadMultiScreenEventsListener({
		[PlayerEvent.PLAY_LAST_SONG]: () => {
			if (!lastSong) {
				return;
			}
			dispatch(setVolumeBarDisplay(false));
			dispatch(deleteAllSongs());
			dispatch(saveCurrentSong(lastSong.song ?? null));
			sendMultiScreenEventToIpad(PlayerEvent.SET_SESSION_END_OVERLAY);
		},
	});

	return (
		<Stack sx={{ mr: 2 }} direction={"row"} alignItems="center" justifyContent="space-between" width={"100%"}>
			<LastSongItemText {...{ lastSong }} />
			<CancelOutlinedIcon onClick={clearLastSong} />
		</Stack>
	);
};

export default LastSongItemWrapper;
